// This file has optional callbacks for tables where a table entry
// needs to be checked for accuracy before saving. 
// Define functions below with name 'table_name' + _save_callback
// The function will be passed the item that is attempting to save
// after checking return a null or empty string if no error
// return an error string if there is an error
import axiosInstances from '@/../../coreui/server/axiosInstances'
import {loadWorkflow} from "@/../../cortex/src/compFunctions/useWorkflow.js"

export default {
  methods: {
    // callback for dev_todo table in CRM module
    // async dev_todo_save_callback(item) {
    //   console.log('dev_todo_save_callback called with item: ', item)
    //   return null
    // },
    async cul_plants_save_callback(item) {
      console.log('cul_plants_save_callback called: ', item)
      if (item.mark_as_dead != undefined && item.mark_as_dead != null && item.mark_as_dead.toLowerCase() == 'yes') {
        if (item.waste_method == undefined || item.waste_method == undefined || item.mix_material == undefined || item.mix_material == undefined ||
          item.dead_weight == undefined) {
          return 'Waste Method, Mix Material and Dead Weight should all be specified'
        } else {
          return 'continue'
        }
      }
      return 'continue'
    },
    async cul_plantings_save_callback(item) {
      console.log('cul_plantings_save_callback_called: ', item)
      let err = []
      let orig = null, errMsg = ''
      if (item.strain === null || item.strain === '') err.push('Strain')
      if (item.room === null || item.room === '') err.push('Room')
      if (item.mtag === null || item.mtag === '') err.push('METRC #')
      if ((item.origin === null || item.origin === '') && item.type !== 'Seed') err.push('Source Pkg')
      if (item.orig === null || item.orig === '' || isNaN(parseInt(item.orig)) || parseInt(item.orig) < 1 || parseInt(item.orig) > 100) orig = 'Original Count must be between 1 and 100'
      if (err.length === 0 && orig === null) return 'continue'
      if (err.length > 0) {
        errMsg = 'The following fields can not be empty: '
        errMsg += err.join(',')
        errMsg += '. '
      } else errMsg = ''
      if (orig != null) {
        errMsg += orig
      }
      return errMsg
    },

    async ota_delete_callback(item) {
      console.log('delete call back called: ', item)
      try {
        await axiosInstances.loginServer.delete('/dt/v1/ota/' + item._id)
        await axiosInstances.loginServer.delete('/ota/' + item.name)
      } catch (ex) {
        console.log(ex)
      }
      this.updateSortedTable()
      return 'stop' // don't do anything more for delete
    }, 

    async auth_metrc_default_add_callback() {
      console.log('add callback called for auth_metrc_default')
      const c = () => import('@/components/workflows/MetrcGlobalPref.vue')
      let obj = {
        form: "metrc-global-pref",
        title: "metrcpref",
        component: c,
        popup: true
      }
      return obj
    },
    async groups_add_callback() {
      console.log('add callback called for set_groups')
      const c = () => import ('@/components/teams/Group.vue')
      let obj = {
        form: "groups",
        title: "groups",
        component: c,
        popup: true
      }
      return obj
    },
    async crm_release_notes_add_callback(){
      console.log(`add callback for crm_release_notes`)
      let workflow = loadWorkflow("crm_release_notes")
      return workflow
    },
    async crm_release_notes_edit_callback(item){
      console.log(`edit callback for crm_release_notes`)
      let workflow = loadWorkflow("crm_release_notes", item)
      return workflow
    },
    async auth_metrc_default_edit_callback(item) {
      console.log('edit call back called: ', item)
      const c = () => import('@/components/workflows/MetrcGlobalPref.vue')
      let obj = {
        form: "metrc-global-pref",
        title: "metrcpref",
        item: item["_id"],
        component: c,
        popup: true
      }
      return obj
    },
    async auth_metrc_default_delete_callback(item){
      let payload = {
        action: "metrc_global_pref_delete",
        recid: item._id
      }
      try {
        await axiosInstances.loginServer.post('/dt/v1/temp_manage_intake', payload)
      } catch(ex) {
        console.log(ex)
      }
      return 'stop'
    }, 
  }
}